import * as qs from "query-string";

function filterJSON(res) {
    return res.json();
}

function filterStatus(res) {
    if ((res.status >= 200 && res.status < 300) || res.status == 409) {
        return res;
    }
    if (res.status == 401) {
        const hostname = window && window.location && window.location.origin;
        var domain = hostname + "/webapp/notauth";
        window.location.href = domain;
    }
    const error = new Error(res.statusText);
    error.res = res;
    error.type = "http";
    throw error;
}

export function get(urlString, params) {
    let url = urlString;
    if (params) {
        url = `${urlString}?${qs.stringify(params)}`;
    }
    return fetch(url, {
        credentials: "include"
    })
        .then(filterStatus)
        .then(filterJSON);
}

export function put(url, body) {
    return fetch(url, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CSRF-TOKEN": window.localStorage.getItem('CSRF-TOKEN')
        },
        credentials: "include",
        body: JSON.stringify(body)
    })
        .then(filterStatus)
        .then(filterJSON);
}

export function post(url, body) {

    return fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CSRF-TOKEN": window.localStorage.getItem('CSRF-TOKEN')
        },
        credentials: "include",
        body: JSON.stringify(body)
    })
        .then(filterStatus)
        .then(filterJSON);
}

